import ApiServer from '@/utils/api/ApiServer.js'

export default {
  async fetchTractVisits (_, tractId) {
    const response = await ApiServer.get(`tracts/${tractId}/visits`)
    return response.data
  },
  async createTractVisit (_, requestObject) {
    const response = await ApiServer.post(`tracts/${requestObject.tractId}/visits`, requestObject)
    return response.data
  },
  async updateTractVisit (_, { tractId, visit }) {
    const response = await ApiServer.put(`tracts/${tractId}/visits/${visit.tractVisitId}`, visit)
    return response.data
  },
  async deleteTractVisit (_, requestObject) {
    const { tractId, tractVisitId } = requestObject
    const response = await ApiServer.delete(`tracts/${tractId}/visits/${tractVisitId}`)
    return response.data
  }
}
